import(/* webpackMode: "eager" */ "/app/app/(bookDetailPageLayout)/error.js");
